import { render, staticRenderFns } from "./MessagesPage.vue?vue&type=template&id=e960f0f2&scoped=true&"
import script from "./MessagesPage.vue?vue&type=script&lang=js&"
export * from "./MessagesPage.vue?vue&type=script&lang=js&"
import style0 from "./MessagesPage.vue?vue&type=style&index=0&id=e960f0f2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e960f0f2",
  null
  
)

export default component.exports